/**
 * Amplitude Feature Flag Experiment 'feature key' constants
 */
export const AmplitudeExperiments = {
    AlwaysShowExpensiveLiveShippingQuotes: 'ups-5470',
    AverageLotValueActionCalendarRanking: 'sear-1266-alv-auction-calendar-ranking',
    CuratedCollections: 'laac-2432-curated-collections',
    DidYouMeanZeroResultSearches: 'sear-2212-did-you-mean-zero-result-searches',
    ElasticOnCategoryPages: 'sear-641-use-of-elastic-on-category-pages',
    ExposureVsPageViewedCheck: 'exposure-vs-page-viewed-check',
    HomePageRedesign: 'sear-1758-home-page-redesign',
    ItemPageDiscoverMoreFromThisAuction: 'laac-1126-item-page-discover-more-from-this-auction',
    MyItemsHoverMenu: 'laac-1947-my-items-hover-menu',
    MyItemsShellPersistentLeftNavAndShell: 'laac-2204-my-items-shell-persistent-left-nav-and-shell',
    NewCatalogPageBanner: 'laac-2111-new-catalog-page-banner',
    // new bidding console experiment
    NewBiddingConsole: 'laac-2369-live-bidding-console-phase-2-v3',
    NoReservePriceBadge: 'la-display-no-reserve-message',
    PopularityScoreReRanking: 'sear-1021-popularity-score-re-ranking-v2',
    PriceResultsRedesign: 'sear-1973-price-results-redesign',
    PurchaseProtectionMessaging: 'ups-4437',
    RegistrationTermsAcceptance: 'laac-2553-pricing-transparency-auction-registration',
    SearchResultsAdExperiment: 'ups-4049',
    SearchTileLiveLotPosition: 'sear-1971-search-tile-live-lot-position',
    SimilarLotsUnifiedClip: 'sear-1381-similar-lots-unified-clip',
    SimplifiedCategoryPage: 'simplified-category-page',
    VariantJumpingHomePageCheck: 'variant-jumping-home-page-check',
} as const;

export type AmplitudeExperimentIds = (typeof AmplitudeExperiments)[keyof typeof AmplitudeExperiments];

export const AmplitudeVariants: {
    [key in keyof typeof AmplitudeExperiments]: {
        [variant: string]: string;
        Control: 'control';
        Treatment?: 'treatment';
    };
} = {
    AlwaysShowExpensiveLiveShippingQuotes: {
        Control: 'control',
        AlwaysShowExpensiveQuotes: 'treatment',
    },
    AverageLotValueActionCalendarRanking: {
        Control: 'control',
        Treatment: 'treatment',
    },
    CuratedCollections: {
        Control: 'control',
        Treatment: 'treatment',
    },
    DidYouMeanZeroResultSearches: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ElasticOnCategoryPages: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ExposureVsPageViewedCheck: {
        Control: 'control',
        Off: 'off',
        Treatment: 'treatment',
    },
    NewCatalogPageBanner: {
        Control: 'control',
        Treatment: 'treatment',
    },
    HomePageRedesign: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ItemPageDiscoverMoreFromThisAuction: {
        Control: 'control',
        Treatment: 'treatment',
    },
    MyItemsHoverMenu: {
        Control: 'control',
        Treatment: 'treatment',
    },
    MyItemsShellPersistentLeftNavAndShell: {
        Control: 'control',
        Treatment: 'treatment',
    },
    NewBiddingConsole: {
        Control: 'control',
        Treatment: 'treatment',
    },
    NoReservePriceBadge: {
        Control: 'control',
        Treatment: 'treatment',
    },
    PopularityScoreReRanking: {
        AddPopularityKeepingBidCount: 'treatmenta',
        AddPopularityRemovingBidCount: 'treatmentb',
        Control: 'control',
    },
    PriceResultsRedesign: {
        Control: 'control',
        Treatment: 'treatment',
    },
    PurchaseProtectionMessaging: {
        Control: 'control',
        Treatment: 'treatment',
    },
    RegistrationTermsAcceptance: {
        Control: 'control',
        Treatment: 'treatment',
    },
    SearchResultsAdExperiment: {
        Control: 'control',
        NewDesign: 'new-design',
    },
    SearchTileLiveLotPosition: {
        Control: 'control',
        Treatment: 'treatment',
    },
    SimilarLotsUnifiedClip: {
        Control: 'control',
        Treatment: 'treatment',
    },
    SimplifiedCategoryPage: {
        Control: 'control',
        Treatment: 'treatment',
    },
    VariantJumpingHomePageCheck: {
        Control: 'control',
        Treatment: 'treatment',
    },
} as const;

export type AmplitudeExperimentsVariantIds = (typeof AmplitudeVariants)[keyof typeof AmplitudeVariants];
